import React, { useEffect } from 'react'
import gsap from 'gsap'
import DetectClickOutside from 'utils/hooks/detectClickOutside'
import { useGlobalState } from 'utils/hooks/globalStateProvider'

export const PROVIDER_YOUTUBE = 'YouTube'
export const PROVIDER_LOOM = 'Loom'

export const getYoutubeId = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)

  return match && match[2].length === 11 ? match[2] : null
}

export const getLoomId = (url) => {
  const splits = url.split('/')
  return splits[splits.length - 1]
}

function Player() {
  const [state, dispatch] = useGlobalState()
  const { openPlayer, provider_name, embed_url } = state

  useEffect(() => {
    const player = document.querySelector('.player-container')
    const playerContent = document.querySelector('.player-container div')

    if (openPlayer) {
      gsap.to(player, 0.2, {
        alpha: 1,
      })

      gsap.to(playerContent, 0.4, {
        delay: 0.4,
        alpha: 1,
        y: 0,
      })

      const bindEscape = (event) => {
        if (event.keyCode === 27) {
          dispatch({ openPlayer: false })
        }
      }

      document.addEventListener('keydown', bindEscape, false)

      return () => {
        const body = document.querySelector('body')
        body.classList.remove('is-hidden')
        document.removeEventListener('keydown', bindEscape, false)
      }
    }
  })

  if (!openPlayer || embed_url === '') return <></>

  return (
    <div className="player-container">
      <span className="icon-cross"></span>
      <div>
        <DetectClickOutside callback={() => dispatch({ openPlayer: false })}>
          <div className="player-container__iframe">
            {provider_name === PROVIDER_YOUTUBE && (
              <iframe
                title={embed_url}
                src={`//www.youtube.com/embed/${getYoutubeId(embed_url)}`}
                allowFullScreen
              />
            )}
            {provider_name === PROVIDER_LOOM && (
              <iframe
                title={embed_url}
                src={`https://www.loom.com/embed/${getLoomId(embed_url)}`}
                allowFullScreen
              />
            )}
          </div>
        </DetectClickOutside>
      </div>
    </div>
  )
}

export default Player
